<template>
    <div class="pieChart">

        <p v-if="hasLine" class="homeComTitle hasLine ml20 mt16">
            <span class="titleLine"></span>
            <span class="flex_1"> {{ title }}</span>
        </p>
        <p v-if="!onlyChart && !hasLine" class="homeComTitle ml20 mt16" :class="[ imgClass ]">
            <span class="flex_1"> {{ title }}</span>
            <!--            <span class="fs14 co_666 font_n">查看详情</span>-->
        </p>
        <p v-if="onlyChart && !hasLine && title && hasIcon" class="homeComTitle ml16 mr16 mt20" :class="[ imgClass ]">
            <span class="flex_1"> {{ title }}</span>
        </p>
        <section class="desc">
            <p v-if="!onlyChart" class="content  fs14" v-html="content"></p>
            <p class="chartTitle fs14 font_b co_666 " v-show="chartTitle">
                <span v-show="hasChartTitleLine" class="titleLine"></span>
                <span class="flex_1" :class="hasChartTitleLine ? 'co_333' : ''"> {{ chartTitle }}</span>
            </p>
            <p v-if="onlyChart && riskLevelStr" class="content  fs14" v-html="riskLevelStr"></p>
        </section>
        <div class="chartBox" :id='chartId'></div>
    </div>
</template>

<script>
import _ from 'lodash'
import utils from '@/util/common'
import common from "@/util/common";

const echarts = require('echarts');

export default {
    name: "PieChart",
    props: {
        title: {
            type: String,
            default: '传播影响力分布'
        },
        hasIcon: Boolean,
        hasLine: Boolean,
        imgClass: {
            type: String,
            default: 'chartText'
        },
        renderData: Array,
        yesterdayData: Array,
        effectForwardCountsByTendency: Array,
        mainAffectEventByTendency: Array,
        chartId: {
            type: String,
            default: "pieChart"
        },
        chartTitle: String,
        industry: {
            type: String,
            default: "金融业"
        },
        entity: {
            type: String,
            default: 'industry',
        },
        chartShowEntityCountUnit: String,
        isEffect: Boolean,
        onlyChart: Boolean,
        riskLevelStr: String,
        hasChartTitleLine: Boolean,// chart title 标题前是否有竖线

    },
    data() {
        return {
            content: '',
            chart: null,
            list: []
        }
    },
    mounted() {
        this.renderFunc()
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    watch: {
        "chartShowEntityCountUnit": function (pre, cur) {
            this.$nextTick(() => {
                if (pre && cur){
                    this.renderFunc()
                }
            })

        }
    },
    methods: {
        setContent(data) {
            data = _.filter(data, e => e.total > 0)
            let sumEvent = _.sumBy(data, 'total');

            this.content = `今日，${common.convertEntityNameStr(this.industry, this.entity)}正面、中性及敏感事件共<span class="font_b">${sumEvent}件</span>`;
            if (sumEvent > 0) {
                this.content += `，事件传播影响力等级最高为<span class="font_b">${common.getAE(data[0].level)}级</span>，涉及事件<span class="font_b">${data[0].total}件</span>，其中敏感事件<span class="font_b">${data[0].negative}件</span>`;
                let tendencyMap = _.keyBy(this.mainAffectEventByTendency, 'tendency')

                this.content += data[0].negative > 0 && tendencyMap['负面']  ? `，主要敏感事件为${common.covertHtmlLink(tendencyMap['负面'])}；` : "；";

                this.content += `正面事件<span class="font_b">${data[0].positive}件</span>`;
                this.content += data[0].positive && tendencyMap['正面'] ? `，主要正面事件为${common.covertHtmlLink(tendencyMap['正面'])}。` : '。';
            } else {
                this.content += '。'
            }


        },
        renderFunc() {
            this.renderData = this.renderData || [];
            let total = _.sumBy(this.renderData, 'total')
            if (!total) {
                total = _.sumBy(this.renderData, 'count')
            }

            this.list = this.renderData.map(item => {
                item.value = item.total || item.count || 0;
                item.percent = total ? utils.formatPercentAndTofixed(item.value , total, 2) : "0.00";
                return item
            });
            if (this.isEffect) {
                this.setContent(this.list);
            }
            // 若data有不为0的情况，则过滤掉所有为0的item
            let targetData = _.filter(this.list, e => {
                return e.value > 0;
            });
            if (targetData.length)
                this.list = targetData;

            this.chart = echarts.init(document.getElementById(this.chartId));
            let option = {
                // title: {
                //     text: this.chartTitle,
                //     textStyle: {
                //         fontSize: 14,
                //         color: '#666666'
                //     }
                // },
                series: [
                    {
                        name: 'Nightingale Chart',
                        type: 'pie',
                        radius: [0, '45%'],
                        center: ['50%', '56%'],
                        // roseType: 'area',
                        hoverAnimation: false,
                        color: ['#03399f', '#386ccf', '#5585e1', '#729ef1', '#bdd5ff',],
                        itemStyle: {
                            normal: {
                                borderRadius: 8
                            }
                        },
                        label: {
                            formatter: (params) => {
                                let str = `{name|${params.name || params.data.label}}`;
                                if(this.chartShowEntityCountUnit){
                                    str = `${str}\n{value|${params.data.percent || params.percent}% ${
                                        this.chartShowEntityCountUnit == "篇" ? (params.data.articleCount || params.data.value ) : params.data.count
                                    }${this.chartShowEntityCountUnit}}`
                                }else {
                                    str = `${str}\n{value|${params.data.percent || params.percent}% }`;
                                }
                                return str;
                            },
                            rich: {
                                name:{
                                    color: '#666666',
                                    fontSize: 12,
                                    // padding: [0, 0, 0, 10],
                                    top:20
                                },
                                value: {
                                    padding: [10, 0, 0, 0],
                                    color: '#666666',
                                }
                            }
                        },
                        labelLine: {
                            normal:{
                                length: 15,
                                length2: 12,
                                lineStyle: {
                                    color: '#c4c2c2',
                                },
                            }
                        },
                        data: this.list,
                    }
                ]
            };
            this.chart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.pieChart {
    background-color: #FFFFFF;
    .homeComTitle {
        position: relative;

        .co_666 {
            position: absolute;
            right: 0;
        }
    }
    .desc{
        padding: 0px 16px;
        .content {
            margin-top: 12px;
        }
    }

    .chartTitle{
        margin-top: 20px;
        padding: 0px 0px 0px 4px !important;
    }

    .chartBox {
        //margin-top: 28px;
        height: 240px;
    }


}
</style>